export const STORAGE_KEYS = {
  LANGUAGE: "oryxology-language",
};